<div class="back-button" (click)="onGoBack()">
  <i class="fa-solid fa-arrow-left"></i>
</div>
